import { Flex, Typography } from 'antd';
import {
  QuestionConfigWithResponse,
  QuestionnairePage
} from '../../_components/questionnaire-page';
import { BigDarkButton } from 'components/button/big-dark-button';
import { QuestionnairePaginationCombinedGeneralProps } from '../../_components/questionnaire-paginator-types';
import { FormattedSection } from 'features/patient/assessment/questionnaires/paginationSlice';

interface DisplaySectionProps {
  currentSection: FormattedSection;
  currentSectionIndex: number;
  submitReady: boolean;
  currentPage: number;
  pageTitle: QuestionnairePaginationCombinedGeneralProps<any>['pageTitle'];
  handleOnValueChange: (
    item: Pick<QuestionConfigWithResponse, 'title' | 'value'>
  ) => void;
  handleNextOrSubmit: () => void;
  isSubmitting: boolean;
}

export function DisplaySection(props: DisplaySectionProps) {
  const resolvedBeforeLabel: string =
    props.currentSection.beforeLabel ?? 'Unable to do';
  const resolvedAfterLabel: string =
    props.currentSection.afterLabel ?? 'Without any difficulty';

  const actionButtonLabel = props.submitReady ? 'Submit' : 'Next';
  const disabled = props.currentSection.page
    .at(props.currentPage)
    ?.some(_ => _.value === -1);

  const resolvedPageTitle =
    typeof props.pageTitle === 'function'
      ? props.pageTitle(props.currentSectionIndex, props.currentPage)
      : props.pageTitle;

  return (
    <>
      <Flex justify="center" style={{ width: '100%' }}>
        <Typography.Title style={{ fontWeight: 'bolder' }}>
          {resolvedPageTitle}
        </Typography.Title>
      </Flex>

      <QuestionnairePage
        items={props.currentSection.page[props.currentPage]}
        min={props.currentSection.min}
        max={props.currentSection.max}
        onChange={props.handleOnValueChange}
        beforeLabel={resolvedBeforeLabel}
        afterLabel={resolvedAfterLabel}
        type={props.currentSection.type}
        colorsForward={props.currentSection.colorsForward}
        iconsForward={props.currentSection.iconsForward}
      />

      <div
        style={{
          display: 'flex',
          alignItems: 'flexEnd',
          flexDirection: 'row',
          justifyContent: 'flex-end'
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <BigDarkButton
            minWidth={128}
            minHeight={60}
            disabled={disabled}
            onClick={props.handleNextOrSubmit}
            loading={props.isSubmitting}
            label={actionButtonLabel}
          />
        </div>
      </div>
    </>
  );
}
